const SESSION_KEYS = [
  'access_token',
  'refresh_token',
  'user_full_name',
  'selected_project_id',
  'selected_project_name',
  'user_profile_photo',
  'user_projects',
  'cached_user',
  'telegram_miniapp',
];

const trimTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');

const explicitAuthWebUrl = trimTrailingSlash(process.env.REACT_APP_AUTH_WEB_URL || '');
const explicitAuthApiUrl = trimTrailingSlash(process.env.REACT_APP_AUTH_API_URL || '');

export const IS_UNIFIED_AUTH_CONFIGURED = Boolean(explicitAuthWebUrl || explicitAuthApiUrl);

const deriveAuthWebBase = () => {
  if (explicitAuthWebUrl) {
    return explicitAuthWebUrl;
  }

  if (explicitAuthApiUrl) {
    try {
      const parsed = new URL(explicitAuthApiUrl, window.location.origin);
      let pathname = trimTrailingSlash(parsed.pathname || '/');
      if (pathname.endsWith('/api')) {
        pathname = pathname.slice(0, -4);
      }
      parsed.pathname = pathname || '/';
      parsed.search = '';
      parsed.hash = '';
      return trimTrailingSlash(parsed.toString());
    } catch {
      // ignore and fallback below
    }
  }

  return '';
};

export const UNIFIED_AUTH_WEB_URL = deriveAuthWebBase();

export const clearLocalSession = () => {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
};

const toRelativePath = (value) => {
  if (!value) {
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
  }

  if (typeof value === 'string') {
    if (value.startsWith('/')) {
      return value;
    }
    try {
      const parsed = new URL(value, window.location.origin);
      return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
      return `${window.location.pathname}${window.location.search}${window.location.hash}`;
    }
  }

  if (typeof value === 'object' && value.pathname) {
    return `${value.pathname}${value.search || ''}${value.hash || ''}`;
  }

  return `${window.location.pathname}${window.location.search}${window.location.hash}`;
};

export const buildUnifiedAuthUrl = (nextPath) => {
  if (!UNIFIED_AUTH_WEB_URL) {
    const loginUrl = new URL('/login', window.location.origin);
    const relativeNextPath = toRelativePath(nextPath);
    if (relativeNextPath && relativeNextPath !== '/login') {
      loginUrl.searchParams.set('next', relativeNextPath);
    }
    return loginUrl.toString();
  }

  const authUrl = new URL(UNIFIED_AUTH_WEB_URL, window.location.origin);
  const returnTo = new URL(toRelativePath(nextPath), window.location.origin).toString();
  authUrl.searchParams.set('service_hint', 'crm');
  authUrl.searchParams.set('return_to', returnTo);
  return authUrl.toString();
};

export const redirectToUnifiedAuth = (nextPath) => {
  window.location.assign(buildUnifiedAuthUrl(nextPath));
};
